/**
 * Replacement for platform feature flags
 * fg but is cawifg so not to accidentally import the wrong thing
 */
export const cawifg = (key: string): boolean => {
	try {
		return Boolean(window.__PLATFORM_FEATURE_FLAGS__?.booleanResolver?.(key));
	} catch (error) {
		return false;
	}
};
